// extracted by mini-css-extract-plugin
export default {"container":"N0-z","heading":"O0-z","links":"P0-z","copy":"Q0-z","subCopy":"R0-z","linksLeft":"S0-z","linksCenter":"T0-z","linksRight":"U0-z","link":"V0-z","onlyLink":"W0-z"};